import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "space-y-3 p-3 animate__animated animate__fadeIn" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "flex flex-row justify-end" }
const _hoisted_4 = { class: "flex flex-row items-center bg-primary-light py-2 px-4 rounded" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 01-.923 1.785A5.969 5.969 0 006 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337z"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<svg class=\"h-6 w-6\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"4\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><line x1=\"16\" y1=\"2\" x2=\"16\" y2=\"6\"></line><line x1=\"8\" y1=\"2\" x2=\"8\" y2=\"6\"></line><line x1=\"3\" y1=\"10\" x2=\"21\" y2=\"10\"></line></svg>", 1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "flex flex-row bg-blue-50 rounded-full justify-between text-xs p-3"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, " We don’t have information about this candidate, we suggest you go edit the profile information. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommentsForm = _resolveComponent("CommentsForm")!
  const _component_ScheduleMeetingSection = _resolveComponent("ScheduleMeetingSection")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_TimeLine = _resolveComponent("TimeLine")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.option = 1)),
            class: _normalizeClass(["mr-4 p-2 rounded", {
              'text-white bg-primary': _ctx.option === 1,
              'text-primary bg-primary-light': _ctx.option !== 1,
            }])
          }, _hoisted_6, 2),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.option = 2)),
            class: _normalizeClass(["p-2 rounded", {
              'text-white bg-primary': _ctx.option === 2,
              'text-primary bg-primary-light': _ctx.option !== 2,
            }])
          }, _hoisted_8, 2)
        ])
      ]),
      (_ctx.option === 1)
        ? (_openBlock(), _createBlock(_component_CommentsForm, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.option === 2)
        ? (_openBlock(), _createBlock(_component_ScheduleMeetingSection, {
            key: 1,
            jobCandidate: _ctx.jobCandidate
          }, null, 8, ["jobCandidate"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.timeLine && _ctx.timeLine.length <= 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("button", {
            class: "text-primary",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openEdit && _ctx.openEdit(...args)))
          }, " Edit candidate profile ")
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading && !_ctx.timeLine)
      ? (_openBlock(), _createBlock(_component_Skeleton, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.option === 1 && _ctx.timeLine && _ctx.timeLine.length > 0 && !_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_TimeLine, {
          key: 2,
          timeline: _ctx.timeLine,
          candidate: _ctx.candidate
        }, null, 8, ["timeline", "candidate"]))
      : _createCommentVNode("", true)
  ]))
}